import React from "react";
import OverviewStyle from "../../../assets/stylesheets/farm-detail/sections/FarmOverview.module.css";
import FarmDetailStyle from "../../../assets/stylesheets/farm-detail/FarmDetailPage.module.css";

// import Logger from "../../../utils/logger";

// const log = Logger.create('FarmOverview');


export default function FarmOverview({
  name,
  description,
}) {
  const overviewContainerTitle = `About ${name}`;
  return (
    <section className={OverviewStyle["overview-container"]}>
      {/* Overview Box */}
      <div className={`${FarmDetailStyle["farmDetail-box"]} ${OverviewStyle["overview-box"]}`}>
        <h3 className={`${FarmDetailStyle["farmDetail-title"]}`}>{overviewContainerTitle}</h3>
        <div className={OverviewStyle["overview-show-more-button-container"]}>
          <div className={`${OverviewStyle["overview-text"]}`}>
            <p>{description}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
